var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container container-fluid p-0"},[_c('LeftNav',{attrs:{"router":_vm.$router,"route":_vm.$route,"permissions":_vm.permissions,"app":"pinnacle"}}),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.activeViewKey,staticClass:"router-view"})],1),_c('MaintenanceModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }